// a shameless ripoff of @components/Comments/CardWrapper
import React from 'react'

import { Card } from '@mantine/core'
import cn from 'classnames'

import styles from './CardWrapper.module.css'

export const CardWrapper = ({
  children,
  onClick,
  selected,
}: {
  children: React.ReactNode
  onClick?: Callback
  selected?: boolean
}) => {
  const classes = cn(styles.wrapper, {
    [styles.wrapper___selected]: selected,
  })

  return (
    <Card
      className={classes}
      shadow="none"
      px={10}
      pt={10}
      pb={10}
      withBorder={false}
      onClick={onClick}
    >
      {children}
    </Card>
  )
}
